import { useDispatch } from "react-redux";
import { loginUser } from "../redux/reducers/loginReducer";
import { useForm } from "react-hook-form";
import { Cookie } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

export const useLoginForm = () => {
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors,isValid }, setError } = useForm();
  const dispatch = useDispatch();

  const onSubmit = (data) => {    
    // Call the loginUser action with email and password
    dispatch(loginUser({payload:data, navigate,Cookie, setError}));
  };

  return {
    register,
    handleSubmit,
    onSubmit,
    errors,
    isValid
  };
};
